export enum LOGS_CONFIG_ENUM {
    BOARDITEMDATA_UPDATE_STATUSCHANGE = 'BOARD_ITEM_DATA_UPDATE_STATUS_CHANGE',
    SETTINGS = 'SETTINGS',
}

export enum LOGS_OBJECT_TYPE {
    WORKSPACE = 'WORKSPACE',
    BOARD = 'BOARD',
    BOARD_VIEW = 'BoardView',
    ITEM_STATUS = 'ItemStatus',
    ITEM_DATA = 'ITEM_DATA',
    REMINDER = 'Reminder',
    USERINFO = 'UserInfo',
    SETTING = 'Setting',
    TENANT = 'TENANT',
}

export enum LOGS_EVENT_TYPE {
    CREATE = 'CREATE',
    UPDATE = 'UPDATE',
    DELETE = 'DELETE',
    MOVE = 'MOVE',
    UPDATECOMMENT = 'UpdateComment',
    REMOVECOMMENT = 'RemoveComment',
}
